// extracted by mini-css-extract-plugin
export var legendIndicator = "_cl-1";
export var legendRight = "_cl-0";